<template>
  <div class="rtl">
    <m-form
      :title="title"
      :items="items"
      :cols="cols"
      :canSubmit="canSubmit"
      :canDelete="canDelete"
      :is-editing.sync="isEditing"
      :can-edit="user.active_company.id == item.id"
      :showListBtn="false"
      :show-list-export-btn="false"
      :show-navigation-btns="false"
      :show-clear-btn="false"
      @click:row="setItem"
      @clearForm="clearForm"
      @submit="submit"
      @delete="deleteItem"
    >
      <template #default>
        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete
              class="rounded-lg"
              label=" نوع کسب و کار"
              :items="TYPES"
              v-model="item.is_real"
              item-text="name"
              item-value="value"
              :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field class="rounded-lg" label=" * نام کسب و کار" v-model="item.name" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12" md="4">
            <m-file-input
              label="لوگو"
              :disabled="!isEditing"
              v-model="item.logo"
              :delete-attachment.sync="item.delete_logo"
            />
          </v-col>
          <v-col cols="12" md="12" v-if="item.id">
            <v-card class="rounded-lg success white--text pt-3 pb-3">
              <v-row>
                <v-col cols="12" md="2" class="d-flex justify-center">
                  <v-img src="/img/icons/plans.svg" max-width="30" max-height="30"> </v-img>
                </v-col>
                <v-col cols="12" md="10" class="pt-4 d-flex text-center justify-center">
                  <span>
                    بسته اشتراکی:
                    {{ item.plan_title }}
                  </span>
                  <span class="mr-10">
                    تاریخ انقضا:
                    {{ item.expired_at }}
                  </span>
                  <span class="mr-10">
                    تعداد کاربر:
                    {{ item.users_count }}
                  </span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" v-if="!item.is_real">
            <v-text-field class="rounded-lg" label="شناسه ملی" v-model="item.shenase" :disabled="!isEditing" :rules="shenaseMeliRules" />
          </v-col>
          <v-col cols="12" md="6" v-if="!item.is_real">
            <v-text-field class="rounded-lg" label="کد اقتصادی" v-model="item.eghtesadi_code" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              class="rounded-lg"
              :label="item.is_real ? ' نام و نام خانوادگی مدیر کسب و کار' : 'نام و نام خانوادگی مدیرعامل / نماینده'"
              v-model="item.ceo_name"
              :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="6">
            <m-national-code
              :label="item.is_real ? ' کد ملی مدیر کسب و کار' : 'کد ملی مدیرعامل / نماینده'"
              v-model="item.ceo_national_code"
              :disabled="!isEditing"
            />
          </v-col>

          <v-col cols="12" md="6" v-if="!item.is_real">
            <v-text-field class="rounded-lg" label="شماره ثبت" v-model="item.sabt_number" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12" md="6" v-if="!item.is_real">
            <date v-model="item.sabt_date" label=" تاریخ ثبت" :default="false" :disabled="!isEditing" />
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field class="rounded-lg" label="تلفن 1" v-model="item.phone1" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field class="rounded-lg" label="تلفن 2" v-model="item.phone2" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field class="rounded-lg" label="فکس" v-model="item.fax" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field class="rounded-lg" label="ایمیل" v-model="item.email" type="email" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              class="rounded-lg"
              label="کد پستی"
              v-model="item.postal_code"
              type="number"
              :disabled="!isEditing"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field class="rounded-lg" label="وبسایت" v-model="item.website" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field class="rounded-lg" label="کشور" v-model="item.country" :disabled="!isEditing" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-textarea class="rounded-lg" rows="3" label="آدرس 1" v-model="item.address1" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12" md="6">
            <v-textarea class="rounded-lg" rows="3" label="آدرس 2" v-model="item.address2" :disabled="!isEditing" />
          </v-col>

          <v-col cols="12">
            <v-textarea class="rounded-lg" rows="3" label="توضیحات" v-model="item.explanation" :disabled="!isEditing" />
          </v-col>
        </v-row>
      </template>

      <template #item.activate="{ item }">
        <v-tooltip v-if="!company || company.id != item.id" top color="secondary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="activeCompany(item)" color="secondary" icon large v-bind="attrs" v-on="on">
              <v-icon>fa-power-off</v-icon>
            </v-btn>
          </template>
          فعال سازی
        </v-tooltip>
        <v-tooltip v-else top color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="success" icon large v-bind="attrs" v-on="on">
              <v-icon>fa-check</v-icon>
            </v-btn>
          </template>
          کسب و کار فعال
        </v-tooltip>
      </template>
    </m-form>
  </div>
</template>
<script>
import { MFormMixin } from "@/components/m-form";
import GetUserApi from "@/views/panel/user/getUserApi";

export default {
  mixins: [MFormMixin, GetUserApi],
  props: {},
  data() {
    return {
      baseUrl: "companies",
      permissionBasename: "company",
      items: [],
      cols: [
        {
          text: "نام",
          value: "name",
        },
        {
          text: "",
          value: "activate",
          sortable: false,
          filterable: false,
        },
      ],
      TYPES: [
        { name: "حقیقی", value: true },
        { name: "حقوقی", value: false },
      ],
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle("کسب و کار");
    },
    createUrl() {
      return `${this.baseUrl}/`;
    },
    updateUrl() {
      return this.item.id && `${this.baseUrl}/${this.item.id}/`;
    },
    deleteUrl() {
      return this.item.id && `${this.baseUrl}/${this.item.id}/`;
    },
    canSubmit() {
      if (this.item.id) return true;
      return false;
    },
    shenaseMeliRules() {
      return [
        (value) => {
          return value.length == 11 || "شناسه ملی باید یازده رقم باشد";
        },
      ];
    },
    // economicCodeRules() {
    //   return [
    //     (value) => {
    //       return value.length == 12 || "کد اقتصادی باید دوازده رقم باشد";
    //     },
    //   ];
    // },
  },
  methods: {
    getData() {
      this.getCompanies();
      this.getUser();
    },
    getCompanies() {
      this.request({
        url: this.endpoint("companies/list"),
        method: "get",
        success: (data) => {
          this.items = data;
        },
      });
    },
    getSerialized() {
      let item = this.copy(this.item);

      if (typeof item["logo"] == typeof "") {
        delete item["logo"];
      }

      return this.jsonToFormData(item);
    },
    activeCompany(item) {
      if (confirm("با تغییر کسب و کار سایر تب های سامانه بسته می شوند، میخواهید ادامه دهید؟")) {
        this.request({
          url: this.endpoint("users/setActiveCompany"),
          method: "post",
          data: {
            company: item.id,
          },
          success: (data) => {
            this.tabEmit("change:company");
            this.successNotify();
            window.location.reload();
          },
        });
      }
    },
  },
};
</script>
